// extracted by mini-css-extract-plugin
export default {"profile-group":"AvatarGroup_profile-group__osZh2","profile-image":"AvatarGroup_profile-image__lVBOR","remaining-count":"AvatarGroup_remaining-count__-N9zY"};